export { Setores } from './Setores'
